module.exports = __webpack_public_path__ + "static/downloable/calendario_pagos_RRVV_2024.3cac999.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/downloable/calendario_pagos_RRVV_2024.pdf
// module id = gEZh
// module chunks = 1